<div class="container">
  <div class="pt-10">

    <ion-row class="center-content">
      <ion-col size-sm="12" size-md="6" size-lg="10" size-xs="12">
        <ion-row class="borderbottomForTab">
          <ion-col size-sm="10" size-md="9" size-lg="2" size-xs="10" class="mb-10">
            <div>

              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
                  (selectionChange)="viewAssetYear($event.value,'allDashBoard')">
                  <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                    {{sharedService.transformYearToFyFormat(item.year)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

            </div>
          </ion-col>


          <!-- <ion-col size-sm="10" size-md="9" size-lg="3" size-xs="10" class="mb-10">
            <mat-form-field class="w-100 mat-height40 mat-input-style" style="margin-left: 10px;">
              <mat-date-range-input [rangePicker]="startDatePicker">
                <input matStartDate dateInput placeholder="Start date" [(ngModel)]="taskFromDateForAllGraph"
                  (dateChange)="processAllGraphDateRange()">
                <input matEndDate dateInput placeholder="End date" [(ngModel)]="taskToDateForAllGraph"
                  (dateChange)="processAllGraphDateRange()">
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
              <mat-date-range-picker #startDatePicker></mat-date-range-picker>
            </mat-form-field>

          </ion-col>
           -->
          <!-- <ion-col size-sm="10" size-md="9" size-lg="3" size-xs="10" class="mb-10" *ngIf="loggedInUserRole == 'Manager' && !OnlyFinance ">

            <mat-form-field class="w-100 mat-height40 mat-input-style "  style="margin-left: 10px;">
              <mat-select  placeholder="Select Employee"
                (selectionChange)="onEmployeeChangeByManager($event.value)" >
                <mat-option *ngFor="let item of getEmployeeList" [value]="item.employeeId">
                  {{ item.employeeName}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col> -->

          <!-- <ion-col size-sm="10" size-md="9" size-lg="4" size-xs="10" class="mb-10" *ngIf="loggedInUserRole == 'Manager' && !OnlyFinance ">
            <div class="card" (click)="onClickCard('Manager')" style="margin-left: 10px;">
              <div class="d-flex">
                <div>
                  <span><img class="cp" src="././assets/icon/activeEmp.svg" alt=""></span>
                </div>
          
                <ion-row>
                  <ion-col size-sm="6" size-md="3" size-lg="12" size-xs="6">
                    <div class="text-center ml-30">
                      <p class="fs-12 font_semibold cp">No of expenses pending</p>
                      <p class="mt-5 fs-12 font_bold text_green cp">{{pendingWithManager}}</p>
                    </div>
                  </ion-col>
                </ion-row>
              </div>
            </div>
          </ion-col> -->




        </ion-row>
      </ion-col>
      <!-- <ion-col size-sm="12" size-md="6" size-lg="2" size-xs="12">
        <div class="variablepay-period">
          <span class="ml-5 mr-5 icon-download fs-20 material-icons">download</span>
        </div>
      </ion-col> -->
    </ion-row>
  </div>

  <ion-row class="pt-10">
    <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
      <div class="card" (click)="onClickCard(1)">
        <div class="d-flex">
          <div>
            <span><img src="././assets/icon/activeEmp.svg" alt=""></span>
          </div>
          <ion-row>
            <ion-col size-sm="6" size-md="3" size-lg="12" size-xs="6">
              <div class="text-center ml-30">
                <p class="fs-12 font_semibold text-center">No of asset</p>
                <p class="mt-5 fs-12 font_bold Cerulean-Blue cp">{{totalassetCount}}</p>
              </div>
            </ion-col>
          </ion-row>
        </div>
      </div>
    </ion-col>

    <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
      <div class="card" (click)="onClickCard(2)">
        <div class="d-flex">
          <div>
            <span><img src="././assets/icon/activeEmp.svg" alt=""></span>
          </div>
          <ion-row>
            <ion-col size-sm="6" size-md="3" size-lg="12" size-xs="6">
              <div class="text-center ml-30">
                <p class="fs-12 font_semibold cp">No of new asset</p>
                <p class="mt-5 fs-12 font_bold yellow">{{newAssetTotalLength || 0}}</p>
              </div>
            </ion-col>
          </ion-row>
        </div>
      </div>
    </ion-col>
    <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
      <div class="card" (click)="onClickCard(3)">
        <div class="d-flex">
          <div>
            <span><img class="cp" src="././assets/icon/activeEmp.svg" alt=""></span>
          </div>

          <ion-row>
            <ion-col size-sm="6" size-md="3" size-lg="12" size-xs="6">
              <div class="text-center ml-30">
                <p class="fs-12 font_semibold">No of repaired asset</p>
                <p class="mt-5 fs-12 font_bold text_green cp">{{totalrepairedAsset}}</p>
              </div>
            </ion-col>
          </ion-row>
        </div>
      </div>
    </ion-col>
    <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
      <div class="card" (click)="onClickCard(4)">
        <div class="d-flex">
          <div>
            <span><img class="cp" src="././assets/icon/activeEmp.svg" alt=""></span>
          </div>

          <ion-row>
            <ion-col size-sm="6" size-md="3" size-lg="12" size-xs="6">
              <div class="text-center ml-30">
                <p class="fs-12 font_semibold cp">No of recived asset</p>
                <p class="mt-5 fs-12 font_bold text_green cp">{{totalCountRecivedAsset}}</p>
              </div>
            </ion-col>
          </ion-row>
        </div>
      </div>
    </ion-col>

  </ion-row>


  
  <ion-row class="pt-10">
    <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
      <div class="graphs m-50">
        <ion-row class="justify-content-center">
          <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
            <div class="fs-16 font_bold">Asset Employee Count</div>
          </ion-col>
          <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
            <div class="d-flex graph-icon">
              <span (click)=" switchAssettypeGraph('bar')">
                <img *ngIf="isAssetTypeIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="" class="cp">
                <img *ngIf="isAssetTypeIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
              </span>
              <span (click)="switchReimbursementTypeTable()">
                <img *ngIf="!isAssetTypeTable" src="././assets/icon/tableIcon.svg" alt="" class="cp">
                <img *ngIf="isAssetTypeTable" src="././assets/icon/TableIconActive.svg" alt="">
              </span>
              <span (click)=" switchAssettypeGraph('line')">
                <img *ngIf="isAssetTypeIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="" class="cp">
                <img *ngIf="isAssetTypeIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
              </span>
              <span>
                <img (click)="downloadChartAsPDF('Asset-Employee-Count')" src="././assets/icon/downloadIcon.svg" alt=""
                  class="cp">
              </span>
            </div>
          </ion-col>
        </ion-row>
        <div class="mt-10 mb-10">
          <ion-row>
            <div class="d-flex ">
              <mat-form-field class="w-60 mat-height40 mat-input-style">
                <mat-select placeholder="Select" [(ngModel)]="selectedYearForAsset1"
                  (selectionChange)="viewAssetYear($event.value,'first')">
                  <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                    {{sharedService.transformYearToFyFormat(item.year)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>


            </div>
          </ion-row>
        </div>


        <ion-col size-sm="12" size-md="12" size-lg="12" size-xl="12">
          <div [ngClass]="{'dispNone' : !isAssetTypeTable}">
            <div class="dashboardGraphTable">
              <table id="asset-type-table-data">
                <thead>
                  <tr class="custom-size">
                    <th>Asset Resolution Time </th>
                    <th> Employee Count</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of isAsseTableGraphOne">
                    <td>{{data.xAxisValueData}}</td>
                    <td>{{data.seriesValueOneData}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div [ngClass]="{'dispNone' : isAssetTypeTable}" id="bar-line-chart" style="width: 550px; height: 400px;"
            class="col-xl-12"></div>
        </ion-col>
      </div>
    </ion-col>
    <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
      <div class="graphs m-50">
        <ion-row class="justify-content-center">
          <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
            <div class="fs-16 font_bold">Asset Repaired Count</div>
          </ion-col>
          <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
            <div class="d-flex graph-icon">
              <span (click)="switchrepaiedAssetGraph('bar')">
                <img *ngIf="isRepairedByAssetIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="" class="cp">
                <img *ngIf="isRepairedByAssetIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
              </span>
              <span (click)="switchrepaiedAssetGraphForTable()">
                <img *ngIf="!isRepairedByAssetTable" src="././assets/icon/tableIcon.svg" alt="" class="cp">
                <img *ngIf="isRepairedByAssetTable" src="././assets/icon/TableIconActive.svg" alt="">
              </span>
              <span (click)="switchrepaiedAssetGraph('line')">
                <img *ngIf="isRepairedByAssetIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="" class="cp">
                <img *ngIf="isRepairedByAssetIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
              </span>
              <span>
                <img (click)="downloadChartAsPDF('Asset Resolution')" src="././assets/icon/downloadIcon.svg" alt=""
                  class="cp">
              </span>
            </div>
          </ion-col>
        </ion-row>
        <div class="mt-10 mb-10">
          <ion-row>
            <div class="d-flex ">
              <mat-form-field class="w-60 mat-height40 mat-input-style">
                <mat-select placeholder="Select" [(ngModel)]="selectedYearForAsset2"
                  (selectionChange)="viewAssetYear($event.value,'second')">
                  <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                    {{sharedService.transformYearToFyFormat(item.year)}}
                  </mat-option>
                </mat-select>


              </mat-form-field>
              <!-- First Date Range Picker -->


              <!-- Second Date Range Picker -->
              <!-- <mat-form-field class="w370 mat mat-height40 mat-input-style mr-15" style="margin-left: 10px;">
                <mat-date-range-input [rangePicker]="secondDatePicker">
                  <input matStartDate dateInput placeholder="Start date" [(ngModel)]="taskFromDateForThirdGraph"
                    (dateChange)="processThirdGraphDateRange()">
                  <input matEndDate dateInput placeholder="End date" [(ngModel)]="taskToDateForThirdGraph"
                    (dateChange)="processThirdGraphDateRange()">
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="secondDatePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #secondDatePicker></mat-date-range-picker>
              </mat-form-field> -->


            </div>
          </ion-row>
        </div>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div [ngClass]="{'dispNone' : !isRepairedByAssetTable}">
            <div class="dashboardGraphTable">
              <table id="table-Asset-Resolution-data">
                <thead>
                  <tr class="custom-size">

                    <th>Asset Name</th>
                    <th>Asset repaired Day</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of isAsseTableGraphTwo">

                    <td>{{data.xAxisValueData}}</td>
                    <td>{{data.seriesValueOneData}} {{'Days'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div [ngClass]="{'dispNone' : isRepairedByAssetTable}" id="bar-line-repaired-chart"
            style="width: 550px; height: 400px;">
          </div>
        </ion-col>


      </div>
    </ion-col>
  </ion-row>
  <!-- second row for graph -->
  <ion-row class="pt-10">
    <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
      <div class="graphs m-50">
        <ion-row class="justify-content-center">
          <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
            <div class="fs-16 font_bold">Asset Allocation Days</div>
          </ion-col>
          <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
            <div class="d-flex graph-icon">
              <span (click)="switchhowManyTimeRepairedAsset('bar')">
                <img *ngIf="isswitchhowManyTimeRepairedAssetIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt=""
                  class="cp">
                <img *ngIf="isswitchhowManyTimeRepairedAssetIcon == 'bar'" src="././assets/icon/BarGraphActive.svg"
                  alt="">
              </span>
              <span (click)="switchhowManyTimeRepairedAssetTable()">
                <img *ngIf="!isswitchhowManyTimeRepairedAssetTable" src="././assets/icon/tableIcon.svg" alt=""
                  class="cp">
                <img *ngIf="isswitchhowManyTimeRepairedAssetTable" src="././assets/icon/TableIconActive.svg" alt="">
              </span>
              <span (click)="switchhowManyTimeRepairedAsset('line')">
                <img *ngIf="isswitchhowManyTimeRepairedAssetIcon != 'line'" src="././assets/icon/lineChartIcon.svg"
                  alt="" class="cp">
                <img *ngIf="isswitchhowManyTimeRepairedAssetIcon == 'line'" src="././assets/icon/activeLineChart.svg"
                  alt="">
              </span>
              <span>
                <img (click)="downloadChartAsPDF('Asset Repaired Count')" src="././assets/icon/downloadIcon.svg" alt=""
                  class="cp">
              </span>
            </div>
          </ion-col>
        </ion-row>
        <div class="mt-10 mb-10">
          <ion-row>
            <div class="d-flex ">
              <mat-form-field class="w-60 mat-height40 mat-input-style">
                <mat-select placeholder="Select" [(ngModel)]="selectedYearForAsset3"
                  (selectionChange)="viewAssetYear($event.value,'third')">
                  <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                    {{sharedService.transformYearToFyFormat(item.year)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>



            </div>
          </ion-row>
        </div>


        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div [ngClass]="{'dispNone' : !isswitchhowManyTimeRepairedAssetTable}">
            <div class="dashboardGraphTable">
              <table id="table-data-asset-repaired-count">
                <thead>
                  <tr class="custom-size">
                    <th>Expense Type </th>
                    <th>Amout paid by finance</th>

                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of isAssetTableGraphThird">
                    <td>{{data.xAxisValueData}}</td>
                    <td>{{data.seriesValueOneData}} {{'Days'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div [ngClass]="{'dispNone' : isswitchhowManyTimeRepairedAssetTable}" id="bar-line-asset-repaired-chart"
            style="width: 550px; height: 400px;"></div>
        </ion-col>
      </div>
    </ion-col>
    <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
      <div class="graphs m-50">
        <ion-row class="justify-content-center">
          <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
            <div class="fs-16 font_bold">Asset Allocation Time</div>
          </ion-col>
          <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
            <div class="d-flex graph-icon">
              <span (click)="switchhowManyDaysToAssignAsset('bar')">
                <img *ngIf="isswitchhowManyDaysToAssignAssetIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt=""
                  class="cp">
                <img *ngIf="isswitchhowManyDaysToAssignAssetIcon == 'bar'" src="././assets/icon/BarGraphActive.svg"
                  alt="">
              </span>
              <span (click)="switchhowManyDaysToAssignAssetTable()">
                <img *ngIf="!isswitchhowManyDaysToAssignAssetTable" src="././assets/icon/tableIcon.svg" alt=""
                  class="cp">
                <img *ngIf="isswitchhowManyDaysToAssignAssetTable" src="././assets/icon/TableIconActive.svg" alt="">
              </span>
              <span (click)="switchhowManyDaysToAssignAsset('line')">
                <img *ngIf="isswitchhowManyDaysToAssignAssetIcon != 'line'" src="././assets/icon/lineChartIcon.svg"
                  alt="" class="cp">
                <img *ngIf="isswitchhowManyDaysToAssignAssetIcon == 'line'" src="././assets/icon/activeLineChart.svg"
                  alt="">
              </span>
              <span>
                <img (click)="downloadChartAsPDF('Asset Allocation Time')" src="././assets/icon/downloadIcon.svg" alt=""
                  class="cp">
              </span>
            </div>
          </ion-col>
        </ion-row>
        <div class="mt-10 mb-10">
          <ion-row>
            <div class="d-flex ">
              <ion-col>

                <mat-form-field class="w-60 mat-height40 mat-input-style">
                  <mat-select placeholder="Select" [(ngModel)]="selectedYearForAsset4"
                    (selectionChange)="viewAssetYear($event.value,'fourth')">
                    <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                      {{sharedService.transformYearToFyFormat(item.year)}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ion-col>

              <ion-col style="width:250px">
                <ng-multiselect-dropdown [placeholder]="'Select Authority'" [settings]="dropdownSettings"
                  [data]="getListForAuthority" [(ngModel)]="selectedAuthority" (onSelect)="onSelectAuthority()"
                  (onDeSelect)="onDelectAuthority()" (onSelectAll)="selectAllAuthority($event)"
                  (onDeSelectAll)="onDeSelectAllAuthority()">
                </ng-multiselect-dropdown>
              </ion-col>

            </div>
          </ion-row>
        </div>


        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div [ngClass]="{'dispNone' : !isswitchhowManyDaysToAssignAssetTable}">
            <div class="dashboardGraphTable">
              <table id="table-data-asset-allocatin-count">
                <thead>
                  <tr class="custom-size">
                    <th>Expense Type </th>
                    <th>Amout paid by finance</th>

                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of isAssetTableGraphFourth">
                    <td>{{data.xAxisValueData}}</td>
                    <td>{{data.seriesValueOneData}} {{'Days'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div [ngClass]="{'dispNone' : isswitchhowManyDaysToAssignAssetTable}" id="bar-line-asset-allocatiom-chart"
            style="width: 550px; height: 400px;"></div>
        </ion-col>
      </div>
    </ion-col>
  </ion-row>


  <!-- fourth -->
  <ion-row class="pt-10">


  </ion-row>
</div>